// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"209":"component---src-templates-dumpsters-kpp-pages-js","684":"cada2cc6","774":"framework"}[chunkId] || chunkId) + "-" + {"209":"f4979b2902176964d91a","212":"620df4384a339191bfd2","589":"e5755b5cf428fee68086","684":"654efbb630a6712242cc","774":"64fb867057913ead4b67"}[chunkId] + ".js";
};